import { Component, OnInit, Input } from '@angular/core';
import { ConfigurationModel, LoginUserModel, CustomAlertModel } from '../../../shared/model';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { UserSharedService } from '../../../shared/services/user-shared.service';
import { IPasswordStrengthCheck } from '../../../model/password-strength-check.model';
import { PasswordChangeModel } from '../../../shared/model/index';

@Component({
    selector: 'app-shared-change-password',
    templateUrl: './change-password.component.html',
    styleUrls: ['./change-password.component.scss']
})
export class SharedChangePasswordComponent implements OnInit {

    @Input('configDetails')
    configDetails: ConfigurationModel = new ConfigurationModel();
    xeevaConfig: ConfigurationModel = new ConfigurationModel();
    loginModel: LoginUserModel = new LoginUserModel();
    public passwordForm: FormGroup;
    isConfigRequired: boolean = true;
    autherroDetail: string = null;
    passtypeboolean1: boolean = false;
    passtypeboolean2: boolean = false;
    passtypeboolean3: boolean = false;
  
    PwdStrengthPower: IPasswordStrengthCheck = {
        className: "",
        isShow: false,
        text: ""
    };
    errorTxt: string = "";
    formSubmit: boolean = false; 
    CanLoad: boolean = false;
    passtypeold: string = 'password';
    passtypenew: string = 'password';
    passtypeconfirm: string = 'password';

    pwdChangeModel: PasswordChangeModel = new PasswordChangeModel();

    constructor(public _shared: UserSharedService, private _router: Router, private _route: ActivatedRoute,
        private fb: FormBuilder) {
        this.GetUserDetail(this.loginModel);
    }

    ngOnInit() {
        
        this.passwordForm = this.fb.group({
            oldPassword: ['', [Validators.required]],
            newPassword: ['', [Validators.required]],
            confirmPassword: ['', [Validators.required]]

        }, {
            validator: this.passwordValidator
        });


    }

    passwordValidator(group: FormGroup) {
        let pass = group.controls.newPassword.value;
        let confirmPass = group.controls.confirmPassword.value;

        return pass === confirmPass ? null : group.controls.confirmPassword.setErrors({ matchPassword: true })
    }

    onSubmit() {
        this.autherroDetail = null;
        if (this.passwordForm.invalid) {
            return;
        }
        this.ChangeUserPassword();

    }
    get f() { return this.passwordForm.controls; }


    passwordStrength(): void {
        var password = this.f.newPassword.value;
        if (password != '') {
            var strength = this.checkStrength(password);
            if (strength == 0) {
                this.PwdStrengthPower = {
                    className: 'short',
                    text: "Too Short", //PasswordStrengthInfo.vToShort,
                    isShow: true
                }
            } ////if value is less than 2
            else if (strength == 1) {
                this.PwdStrengthPower = {
                    className: 'weak',
                    text: "Week",// PasswordStrengthInfo.vWeak,
                    isShow: true
                }
            }
            else if (strength == 2) {
                this.PwdStrengthPower = {
                    className: 'good',
                    text: "Good", //PasswordStrengthInfo.vGood,
                    isShow: true
                }
            }
            else {
                this.PwdStrengthPower = {
                    className: 'strong',
                    text: "Strong",// PasswordStrengthInfo.vStrong,
                    isShow: true
                }
            }
        }
        else {
            this.PwdStrengthPower = {
                className: '',
                text: '',
                isShow: false
            }
        }
    }

    checkStrength(password: string): number {

        //initial strength
        var strength = 0;

        //if the password length is less than 10, return message.
        if (password.length < 10) {
            return strength;
        }
        else {
            strength += 1;//if length is 10 characters or more, increase strength value
        }

        //length is ok, lets continue.



        if (password.match(/([a-z].*[A-Z])|([A-Z].*[a-z])/) && password.match(/([a-zA-Z])/) && password.match(/([0-9])/) && password.match(/([!,@,#,$,%,^,&,*,_])/))
            strength += 1;

        //////if password contains both lower and uppercase characters, increase strength value
        ////if (password.match(/([a-z].*[A-Z])|([A-Z].*[a-z])/)) strength += 1

        //////if it has numbers and characters, increase strength value
        ////if (password.match(/([a-zA-Z])/) && password.match(/([0-9])/)) strength += 1

        //////if it has one special character, increase strength value
        ////if (password.match(/([!,@,#,$,%,^,&,*,_])/)) strength += 1

        /////if password strength good then need to check the strong password combination
        if (strength != 2)
            return strength;

        if (password.length > 10)
            strength += 1;
        //if it has two special characters, increase strength value
        if (password.match(/(.*[!,%,&,@,#,$,^,*,?,_,~].*[!,%,&,@,#,$,^,*,?,_,~])/)) strength += 1;

        //now we have calculated strength value, we can return messages
        return strength;


    }


    ChangeUserPassword(): void {
        if (this.f.newPassword.value != "" && this.f.newPassword.value == this.f.confirmPassword.value) {
            var strength = this.checkStrength(this.f.newPassword.value);
            if (strength >= 2) {
                this.pwdChangeModel.userId = this._shared.userDetails.userId;
                this.pwdChangeModel.customerId = this._shared.userDetails.customerId;
                this.pwdChangeModel.newPassword = this.f.newPassword.value;
                this.pwdChangeModel.oldPassword = this.f.oldPassword.value;
                this._shared.ChangeUserPassword(this.pwdChangeModel).subscribe(
                    data => {
                        console.log(data);
                        if (data != null) {

                            if (data.value == 1) {
                                let msg = new CustomAlertModel();
                                msg.messageType = 1, msg.message = 'Password has been chnaged successfully.', msg.timeOut = 6000;
                                this._shared.SetCustomMessage(msg);
                                
                                this._router.navigate(['/dashboard']);
                            }
                            else if (data.value == 2) {
                                this.autherroDetail = "Password and confirm password does not match ";
                            }
                            else if (data.value == 3) {
                                this.autherroDetail = "The old password is not valid ";
                            }
                            else {
                                this.autherroDetail = "Reset password process fail.";
                            }
                        }
                    });

            }
            else {
                this.autherroDetail = "Password policy do not match.";

            }
        }
        else {
            this.autherroDetail = "Confirm password does not match";
        }


    }

    GetUserDetail(obj: LoginUserModel) {
        this._shared.GetUserDetailforManagePassword(obj).subscribe(
            (res: LoginUserModel) => {
                console.log(res);
                console.log(res.isSuccess);

                if (res != null && res.userId != null && res.userId > 0) {

                }
                else {
                    this._router.navigate(['/login']);
                }

            }
        )
    }


    oldchangePasstype() {
        this.passtypeboolean1 = !this.passtypeboolean1;
        if (this.passtypeboolean1)
            this.passtypeold = "text";
        else
            this.passtypeold = "password"

    }

    newchangePasstype() {
        this.passtypeboolean2 = !this.passtypeboolean2;
        if (this.passtypeboolean2)
            this.passtypenew = "text";
        else
            this.passtypenew = "password"

    }

    confirmchangePasstype() {
        this.passtypeboolean3 = !this.passtypeboolean3;
        if (this.passtypeboolean3)
            this.passtypeconfirm = "text";
        else
            this.passtypeconfirm = "password"

    }
    goBack() {
        this._router.navigate(['./dashboard']);
    }

}

